import React, { useEffect, useRef, useState } from 'react';
import mainModel, { models, STEPS } from './model';
import { GroupSlots } from './GroupSlots';
import { api, remCss } from 'src/helpers';
import { SlotsOfDay } from 'components/slotSchedule/SlotsOfDay';
import { GenerateSchedule } from 'components/slotSchedule/GenerateSchedule';
import { BookedList } from 'components/slotSchedule/BookedList';
import { Reschedule } from 'components/slotSchedule/Reschedule';
import { SlotsOfRange } from 'components/slotSchedule/SlotsOfRange';
import { Book } from 'components/slotSchedule/Book';
import errorDescriptions from 'src/constants/errors';
import { MCError } from '../basic';

export const SlotSchedule = ({
  startDate,
  endDate,
  group, //group list step
  selectedDay, // list slots of day
  doctorId = 0,
  onEndPrevious,
  slot,
  addHour,
  hide,
  popupContainerStyle = {
    position: 'relative',
    width: '100%',
    maxWidth: remCss(1024),
    height: '95%',
    maxHeight: remCss(1060)
  },
  onDone
}) => {
  mainModel.use();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const dataRef = useRef({ doctorId: null });

  useEffect(() => {
    if (dataRef.current.doctorId === doctorId) return;
    dataRef.current.doctorId = doctorId;

    const func = () => {
      setLoading(true);
      mainModel.history = [];
      mainModel.setStateSilent({ doctorId });
      return api('doctor/detail', { id: doctorId || mainModel.state.user?.id }).then(
        ({ error, data: doctor }) => {
          if (error) {
            setLoading(false);
            return setError(errorDescriptions(error));
          }
          const mainProps = { doctor };
          if (group) {
            mainModel.setStateSilent({ step: STEPS.GROUP_SLOTS, ...mainProps });
            models[STEPS.GROUP_SLOTS].setStateInit({ startDate, endDate, group });
          } else if (selectedDay) {
            mainModel.setStateSilent({ step: STEPS.SLOTS_OF_DAYS, ...mainProps });

            models[STEPS.SLOTS_OF_DAYS].setStateInit({ selectedDay, slot, addHour });
          } else {
            mainModel.setStateSilent({ step: STEPS.GENERATE_SCHEDULE, ...mainProps });
            models[STEPS.GENERATE_SCHEDULE].setStateInit({});
          }
          setLoading(false);
        }
      );
    };
    const req = func();
    return () => {
      if (req?.cancel) req?.cancel();
    };
  }, [
    addHour,
    doctorId,
    endDate,
    group,
    selectedDay,
    slot,
    startDate,
    hide,
    onEndPrevious,
    onDone
  ]);

  const comps = [
    {
      id: STEPS.GROUP_SLOTS,
      Comp: GroupSlots
    },
    { id: STEPS.SLOTS_OF_DAYS, Comp: SlotsOfDay },
    {
      id: STEPS.GENERATE_SCHEDULE,
      Comp: GenerateSchedule
    },
    { id: STEPS.BOOKED_LIST, Comp: BookedList },
    { id: STEPS.RESCHEDULE, Comp: Reschedule },
    { id: STEPS.SLOTS_OF_RANGE, Comp: SlotsOfRange },
    { id: STEPS.BOOK, Comp: Book }
  ];

  if (loading) return <div className='mc-popup-contain' style={popupContainerStyle}></div>;
  if (error)
    return (
      <div className='mc-popup-contain' style={popupContainerStyle}>
        <MCError error={error} />
      </div>
    );

  return (
    <>
      {comps.map(({ id, Comp, props }) => (
        <div
          key={id}
          className='mc-popup-contain'
          style={{
            ...popupContainerStyle,
            display: mainModel.state.step === id ? 'flex' : 'none'
          }}
        >
          {(mainModel.state.step === id || mainModel.keepPreviousComponent(id)) && (
            <Comp
              onHide={hide}
              onPrev={mainModel.canBackStep() ? mainModel.backStep : onEndPrevious}
              onDone={(...a) => {
                if (models[id].state.onDone) {
                  models[id].state.onDone(...a);
                } else {
                  onDone(...a);
                }
              }}
              {...props}
            />
          )}
        </div>
      ))}
    </>
  );
};

export default mainModel;
